<template>
  <v-container id="" fluid fill-height class="signup" :style=img_section_style>
    <v-layout align-center justify-center>
      <v-flex xs12 sm10 md6>
        <v-col sm="9" md="12" class="text-center">
          <h1 class="display-1 font-weight-thin mb-4">{{ $t("enter-admin-result") }}</h1>
        </v-col>
        <v-form ref="form" v-model="valid" dark color="white">
          <v-layout align-center justify-center>
            <v-flex sm12 md12>
                <!-- User Email -->
              <v-text-field
                  name="email"
                  :label="$t('user-email') + ' *'"
                  type="text"
                  v-model="email"
                  :rules="[v => !!v || 'Item is required']"
                  required
                  light
                  rounded
                  filled
                  background-color="#fff"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout align-center justify-center>
            <v-btn large rounded style="margin-top: 15px; margin-bottom: 15px;" color="primary" @click.stop="CheckUser"
                    :disabled="email == null || userFound === true">{{
                    $t("continue")
                }}
            </v-btn>
            <v-alert 
                v-if="userFound === true" 
                type="info"
                style="margin-left: 30px; height: 55px;"
              >
                <p>{{ $t('user-found') }}</p>
            </v-alert>
            <v-alert 
                v-else-if="userFound === false" 
                type="warning"
                style="margin-left: 30px; height: 55px;"
              >
                <p>{{ $t('user-not-found') }}</p>
            </v-alert>
          </v-layout>
          <v-layout align-center justify-center v-if="email && step == 2">
            <v-flex sm12 md12>
                <!-- Year -->
                <v-select
                    v-model="year"
                    :items="years"
                    :label="$t('competition-year') + ' *'"
                    :rules="[v => !!v || 'Item is required']"
                    required
                    filled
                    rounded
                    background-color="#fff"
                ></v-select>
                <!-- Day 1 -->
                <v-layout>
                    <v-text-field
                        name="distance"
                        :label="$t('day-1-distance')"
                        type="number"
                        v-model="distance1"
                        :disabled="loading"
                        filled
                        rounded
                        background-color="#fff"
                        style="margin-right: 15px;"
                    ></v-text-field>
                    <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="time1"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        filled
                        rounded
                        background-color="#fff"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="time1"
                                :label="$t('time')"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :disabled="loading"
                                filled
                                rounded
                                background-color="#fff"
                            ></v-text-field>
                        </template>
                        <v-time-picker
                            v-if="menu1"
                            v-model="time1"
                            full-width
                            format="24hr"
                            @click:minute="$refs.menu1.save(time1)"
                            filled
                            rounded
                            background-color="#fff"
                        ></v-time-picker>
                    </v-menu>
                    <v-switch
                        v-model="extra_weight1"
                        :label="$t('extra-weight')"
                        color="#FFF"
                        dark
                        style="margin-left: 15px;"
                    ></v-switch>
                </v-layout>

                <!-- Day 2 -->
                <v-layout>
                    <v-text-field
                        name="distance"
                        :label="$t('day-2-distance')"
                        type="number"
                        v-model="distance2"
                        :disabled="loading"
                        filled
                        rounded
                        background-color="#fff"
                        style="margin-right: 15px;"
                    ></v-text-field>
                    <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="time2"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        filled
                        rounded
                        background-color="#fff"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="time2"
                                :label="$t('time')"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :disabled="loading"
                                filled
                                rounded
                                background-color="#fff"
                            ></v-text-field>
                        </template>
                        <v-time-picker
                            v-if="menu2"
                            v-model="time2"
                            full-width
                            format="24hr"
                            @click:minute="$refs.menu2.save(time2)"
                            filled
                            rounded
                            background-color="#fff"
                        ></v-time-picker>
                    </v-menu>
                    <v-switch
                        v-model="extra_weight2"
                        :label="$t('extra-weight')"
                        color="#FFF"
                        dark
                        style="margin-left: 15px;"
                    ></v-switch>
                </v-layout>

                <!-- Day 3 -->
                <v-layout>
                    <v-text-field
                        name="distance"
                        :label="$t('day-3-distance')"
                        type="number"
                        v-model="distance3"
                        :disabled="loading"
                        filled
                        rounded
                        background-color="#fff"
                        style="margin-right: 15px;"
                    ></v-text-field>
                    <v-menu
                        ref="menu3"
                        v-model="menu3"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="time3"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        filled
                        rounded
                        background-color="#fff"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="time3"
                                :label="$t('time')"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :disabled="loading"
                                filled
                                rounded
                                background-color="#fff"
                            ></v-text-field>
                        </template>
                        <v-time-picker
                            v-if="menu3"
                            v-model="time3"
                            full-width
                            format="24hr"
                            @click:minute="$refs.menu3.save(time3)"
                            filled
                            rounded
                            background-color="#fff"
                        ></v-time-picker>
                    </v-menu>
                    <v-switch
                        v-model="extra_weight3"
                        :label="$t('extra-weight')"
                        color="#FFF"
                        dark
                        style="margin-left: 15px;"
                    ></v-switch>
                </v-layout>

                <!-- Day 4 -->
                <v-layout>
                    <v-text-field
                        name="distance"
                        :label="$t('day-4-distance')"
                        type="number"
                        v-model="distance4"
                        :disabled="loading"
                        filled
                        rounded
                        background-color="#fff"
                        style="margin-right: 15px;"
                    ></v-text-field>
                    <v-menu
                        ref="menu4"
                        v-model="menu4"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="time4"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        filled
                        rounded
                        background-color="#fff"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="time4"
                                :label="$t('time')"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :disabled="loading"
                                filled
                                rounded
                                background-color="#fff"
                            ></v-text-field>
                        </template>
                        <v-time-picker
                            v-if="menu4"
                            v-model="time4"
                            full-width
                            format="24hr"
                            @click:minute="$refs.menu4.save(time4)"
                            filled
                            rounded
                            background-color="#fff"
                        ></v-time-picker>
                    </v-menu>
                    <v-switch
                        v-model="extra_weight4"
                        :label="$t('extra-weight')"
                        color="#FFF"
                        dark
                        style="margin-left: 15px;"
                    ></v-switch>
                </v-layout>
            </v-flex>
          </v-layout>
          <v-layout align-center justify-center>
          <v-flex>
            <v-spacer></v-spacer>
            <v-btn large rounded style="margin-top: 35px; margin-bottom: 30px;" color="primary" @click.stop="submit()" :loading="loading"
                  :disabled="isAddButtonDisabled">{{
                $t("submit")
              }}
            </v-btn>
          </v-flex>
          </v-layout>
        </v-form>

      </v-flex>
    </v-layout>
    <v-snackbar
        v-model="snackbar"
    >
      {{ $t(resp) }}

      <template v-slot:action="{ attrs }">
        <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>

</template>

<script>
import Axios from "@/api/apiconfig";

export default {
  components: {
  },
  name: "CompetitionAdminEntry",
  data: () => ({
    CompetitionEntry: {
      day: null,
      extra_weight: false,
      distance: null,
      time: null,
    },
    distance1: null,
    distance2: null,
    distance3: null,
    distance4: null,
    time1: null,
    time2: null,
    time3: null,
    time4: null,
    modal2: false,
    loading: false,
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    extra_weight1: false,
    extra_weight2: false,
    extra_weight3: false,
    extra_weight4: false,
    snackbar: false,
    file: null,
    file_1: null,
    file_2: null,
    imageUrl: null,
    resp: null,
    valid: null,
    disabled: true,
    kmh: null,
    kmhWarning: false,
    user: null,
    email: null,
    year: null,
    step: 1,
    userFound: null,
  }),
  computed: {
    items: function () {
      return [
        {date: this.$t("day-1"), day: 1},
        {date: this.$t("day-2"), day: 2},
        {date: this.$t("day-3"), day: 3},
        {date: this.$t("day-4"), day: 4}
      ]
    },
    years: function () {
        return [
            2020, 2021, 2022, 2023, 2024, 2025, 2026
      ]
    },
    img_section_style: function () {
      var bgImg = require('@/assets/r4dm_hero_2024.png')
      return {
        "background": 'url(' + bgImg + ')',
        "background-color": "#062F6E !important",
        "background-size": "cover",
      }
    },
    isAddButtonDisabled() {
      return !(this.email && this.year && this.step == 2 && (this.distance1 != null && this.time1 != null || this.distance2 != null && this.time2 != null || this.distance3 != null && this.time3 != null || this.distance4 != null && this.time4 != null));
    },
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    CheckUser() {
      let req = Axios.get('/user/' + this.email, {withCredentials: true}, {
        headers: {
          'Content-Type': 'application/json'
        },
      }).then(response => {
        console.log(response)
        if (response.status === 200) {
            console.log("User found")
            this.user = response.data.data.users[0] // TODO: Fix this craziness in the backend, should return single user not list of 1 user
            console.log(response.data.data.users[0])
            this.userFound = true;
            this.step = 2;
        }
      }).catch(error => {
            console.log("User not found")
            // Create user
            // TODO implement user creation later
            this.userFound = false;
      });
    },
    submit() {
        for (let i = 1; i <= 4; i++) {
            console.log(this['distance' + i], this['time' + i])
          if(this['distance' + i] != null || this['time' + i] != null) {
            this.AddToCompetition(this.year, this.user.public_id, i, this['distance' + i], this['time' + i], this['extra_weight' + i])
          }
        }
        this.resp = "results submitted";
        this.snackbar = true;
    },
    AddToCompetition(year, user_id, day, distance, time, extra_weight) {
        console.log(user_id)
        let body = {};
        body.day = day;
        body.extra_weight = extra_weight;
        body.distance = distance;
        body.time = time;
        body.year = year;
        body.user_id = user_id;
        console.log(body)

        let req = Axios.post('/competition/enter_legacy_result', body, {withCredentials: true}, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        }).then(data => {
          //console.log(data)
          if (data) {
            if (data.status == 201) {
                // Success, reset the form and show success message
                this.resetForm();
                this.resp = "result added successfully";
                this.snackbar = true;
            } else {
                this.resp = data.data.message;
                this.snackbar = true;
            }
          }
        }).catch(error => {
          console.log(error)
          this.resp = error.response.data.message;
          this.snackbar = true;
        });
    },
    timeToMins(time){
      var b = time.split(':');
      return b[0]*60 + +b[1];
    },
    timeFromMins (mins){
      function z(n){return (n<10? '0':'') + n;}
      var h = (mins/60 |0);
      var m = mins % 60;
      return z(h) + ':' + z(m);
    },
    formatNumber (value, no){
      if(value == null){
        return "-"
      } else {
        return value.toFixed(no)
      }
    },
    resetForm() {
        this.user = null;
        this.email = null;
        this.year = null;
        this.step = 1;
        this.distance1 = null;
        this.distance2 = null;
        this.distance3 = null;
        this.distance4 = null;
        this.time1 = null;
        this.time2 = null;
        this.time3 = null;
        this.time4 = null;
        this.extra_weight1 = false;
        this.extra_weight2 = false;
        this.extra_weight3 = false;
        this.extra_weight4 = false;
    }
  },
  watch: {
    /* email: {
      handler(val) {
        // Check if user exists with email
        let req = Axios.get('/user/' + val, {withCredentials: true}, {
            headers: {
                'Content-Type': 'application/json'
            },
            }).then(data => {
                console.log(data)
                if (data) {
                    this.user = data.data.data.user
                } else {
                    // Create user
                    // TODO implement user creation later
                    this.user = null
                }
            }).catch(error => {
                console.log(error)
                this.user = null
            });
        // Handle email change
      }
    } */
    /* CompetitionEntry: {
      handler(val) {
        if(val.distance != null && val.time != null) {
          let minutes = this.timeToMins(val.time);
          let hours = minutes / 60;
          let kmh = val.distance / hours;
          this.kmh = Math.round(kmh * 100) / 100;

          if(kmh < 0.7 || kmh > 35) {
            this.kmhWarning = true
            this.disabled = true;
          } else {
            this.kmhWarning = false
            this.disabled = false;
          }
        }
      },
      deep: true,
    } */
  }
}
</script>

<style scoped>
.signup {
  background-color: #062F6E !important;
  color: white !important;
  padding-top: 30px;
}
.btn-margin {
  margin-top: 20px;
}

.denied-btn {
  margin-top: 30px;
  margin-bottom: 30px;
}

</style>